module.exports = __webpack_public_path__ + "static/img/banner_bg2.cef00fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner_bg2.jpg
// module id = CA82
// module chunks = 9